module.exports = __webpack_public_path__ + "public/media/creator-vector2.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/creator-vector2.png
// module id = ./images/services/creator-vector2.png
// module chunks = 0